import React, {
  useCallback, useContext, useEffect, useState,
} from 'react';
import { push } from 'connected-react-router';
import { useHistory, useRouteMatch } from 'react-router';
import { useDispatch } from 'react-redux';
import { checkChangeResource, getPreventLeaveText } from '../modal-prevent/utils';
import ModalPreventForm from '../modal-prevent/ModalPreventForm';
import { DeferredActionContext } from '../../services/common/DeferredActionContext';

type Props = {
  preventCancelChanges: boolean;
};

const FormPreventRedirectModal = ({ preventCancelChanges }: Props) => {
  const [redirectOpen, setRedirectOpen] = useState(false);
  const { clearActions, processActions } = useContext(DeferredActionContext);
  const [nextRoute, setNextRoute] = useState('');
  const redirectTexts = getPreventLeaveText();
  const { block } = useHistory();
  const { url } = useRouteMatch();
  const dispatch = useDispatch();

  const cancelRedirectHandler = useCallback(() => {
    setRedirectOpen((prev) => !prev);
    dispatch(push(nextRoute));
    processActions();
  }, [setRedirectOpen, nextRoute, dispatch, processActions]);

  const approveRedirectHandler = useCallback(() => {
    setRedirectOpen((prev) => !prev);
    clearActions();
  }, [setRedirectOpen, clearActions]);

  useEffect(() => {
    const unregister = block((e) => {
      if (!redirectOpen && preventCancelChanges && checkChangeResource(url, e.pathname)) {
        setNextRoute(e.pathname);
        setRedirectOpen(true);
        return false;
      }
    });

    return () => unregister();
  }, [setRedirectOpen, setNextRoute, block, url, preventCancelChanges, redirectOpen]);
  // end redirect modal

  return (
    <>
      {
        redirectOpen && preventCancelChanges
        && (
          <ModalPreventForm
            open={redirectOpen}
            cancelHandler={cancelRedirectHandler}
            approveHandler={approveRedirectHandler}
            onEscapeKeyDown={() => { setTimeout(() => { approveRedirectHandler(); }, 250); }}
            title={redirectTexts.title}
            message={redirectTexts.message}
            approveText={redirectTexts.approveText}
            cancelText={redirectTexts.cancelText}
          />
        )
      }
    </>
  );
};

export default FormPreventRedirectModal;
